// frontend/app/locales/fr.ts
export const fr = {
  sidebar: {
    main: "Principal",
    planning: "Planification",
    closings: "Clôtures",
    system: "Système",
    dashboard: "Tableau de bord",
    transactions: "Transactions",
    investments: "Investissements",
    calendar: "Calendrier",
    recurring: "Récurrent",
    envelopes: "Enveloppes",
    debts: "Dettes & Crédits",
    goals: "Objectifs",
    documents: "Boîte Telegram",
    balance: "Balances",
    data: "Données",
    settings: "Paramètres",
    logout: "Se déconnecter",
    login: "Se connecter",
    language: "Langue",
    more: "Plus",
    home: "Accueil",
    expenses: "Dépenses",
    envelopes_short: "Enveloppes",
    wishlist: "Envies",
  },
  settings: {
    title: "Paramètres",
    subtitle: "Gérez vos préférences, votre profil et vos identifiants de sécurité.",
    profile: "Profil Personnel",
    preferences: "Préférences Système",
    security: "Sécurité",
    database_status: "Statut de la Base de Données",
    export_import: "Exporter & Importer",
    email_briefings: "Briefings Quotidiens & Rapports",
    save: "Enregistrer les Paramètres",
    change_password: "Modifier le Mot de Passe",
    current_password: "Mot de Passe Actuel",
    new_password: "Nouveau Mot de Passe",
    confirm_password: "Confirmer le Mot de Passe",
    bio_authentication: "Authentification Biométrique (Passkeys)",
    register_passkey: "Enregistrer un Passkey",
    db_status_msg: "La base de données PostgreSQL est active et synchronisée avec succès.",
    export_btn: "Exporter les Données JSON",
    import_btn: "Importer les Données JSON",
    receive_briefings: "Recevoir le briefing du matin",
    receive_weekly: "Recevoir le rapport hebdomadaire",
    receive_monthly: "Recevoir le rapport mensuel",
    base_currency: "Devise de Référence",
    timezone: "Fuseau Horaire",
    personal_info: {
      username: "Nom d'utilisateur",
      email: "E-mail",
      first_name: "Prénom",
      last_name: "Nom",
      date_of_birth: "Date de naissance",
      phone_number: "Numéro de téléphone",
      address: "Adresse",
      city: "Ville",
      state: "État / Province",
      postal_code: "Code Postal",
      country: "Pays",
      gender: "Genre",
      select_gender: "Sélectionner...",
      male: "Masculin",
      female: "Féminin",
      other_gender: "Autre",
      address_details: "Détails (Bâtiment, Appartement)",
      address_details_placeholder: "Ex. Apt 4B",
      address_placeholder: "Ex. 123 Rue Principale",
      city_placeholder: "Paris",
      state_placeholder: "IDF",
      postal_code_placeholder: "75001",
      job_section: "Emploi & Impôts",
      tax_id: "Identifiant Fiscal",
      tax_id_placeholder: "Numéro fiscal ou similaire...",
      employment_status: "Statut Professionnel",
      employment_status_placeholder: "Employé, Freelance...",
      job_title: "Intitulé du Poste",
      job_title_placeholder: "Ingénieur Logiciel..."
    },
    telegram: {
      title: "Intégration du Bot Telegram",
      desc: "Pour utiliser le bot, envoyez-lui la commande {cmd} pour obtenir votre identifiant, puis saisissez-le ci-dessous.",
      placeholder: "Ex. 123456789"
    },
    password_section: {
      title: "Mot de Passe d'Accès",
      desc: "Mettez régulièrement à jour votre mot de passe pour sécuriser votre compte.",
      btn: "Modifier le Mot de Passe",
      modal_title: "Modifier le Mot de Passe",
      cancel: "Annuler",
      confirm: "Confirmer",
      saving: "Enregistrement en cours..."
    },
    biometric: {
      title: "Connexion Biométrique",
      desc: "Connectez-vous rapidement à l'aide de Face ID, Touch ID ou Windows Hello."
    },
    two_fa: {
      title: "Authentification à Deux Facteurs (2FA)",
      status_active: "ACTIF",
      desc: "Protégez votre compte avec un code à usage unique généré par une application d'authentification.",
      disable_btn: "Désactiver la 2FA",
      enable_btn: "Configurer la 2FA",
      modal_title: "Configurer la 2FA",
      modal_desc: "Scannez ce code avec votre application d'authentification (Google Authenticator, Authy, Raivo, etc.)",
      manual_entry: "Ou saisissez manuellement le code secret :",
      verify_label: "Entrez le code pour vérifier",
      verify_btn: "Activer Maintenant",
      verifying: "Vérification...",
      prompt_disable: "Entrez le code 2FA pour confirmer la désactivation :"
    },
    briefings: {
      morning_label: "Briefing du Matin",
      morning_desc: "Résumé des dépenses de la veille et échéances à venir.",
      weekly_label: "Bilan Hebdomadaire",
      weekly_desc: "Analyse des performances budgétaires chaque semaine.",
      monthly_label: "Résumé Exécutif",
      monthly_desc: "Bilan mensuel détaillé de votre patrimoine net."
    },
    toasts: {
      qr_err: "Erreur lors de la génération du code QR",
      conn_err: "Erreur de connexion",
      two_fa_enabled: "Authentification à deux facteurs activée !",
      invalid_code: "Code invalide",
      two_fa_disabled: "2FA désactivée.",
      disable_failed: "Code invalide. Échec de la désactivation.",
      profile_saved: "Profil mis à jour !",
      save_err: "Erreur lors de l'enregistrement du profil",
      pref_saved: "Préférence enregistrée !",
      pref_save_err: "Impossible d'enregistrer la préférence.",
      export_success: "Données exportées avec succès !",
      export_failed: "Erreur lors de l'exportation des données.",
      passkey_todo: "La fonction Passkey sera restaurée ici",
      password_mismatch: "Les nouveaux mots de passe ne correspondent pas !",
      password_changed: "Mot de passe modifié avec succès !",
      password_change_err: "Erreur lors de la modification du mot de passe",
      loading: "Chargement des paramètres..."
    }
  },
  dashboard: {
    title: "Tableau de Bord Financier",
    subtitle: "Tableau de Bord du Patrimoine Net",
    overview_tab: "Vue d'ensemble",
    wealth_tab: "Patrimoine & FIRE",
    behavior_tab: "Comportement",
    history_tab: "Historique & Enregistrements",
    forecast_tab: "Prévisions",
    merchants_tab: "Commerçants",
    budget_tab: "Budgets",
    seasonality_tab: "Saisonnalité",
    gamification_tab: "RPG Financier",
    investments_tab: "Investissements",
    view_as: "Afficher sous forme de :",
    burn_rate: "Taux de Dépense Quotidien",
    avg_ticket: "Ticket Moyen",
    micro_tx: "Syndrome du Café (<15€)",
    no_spend_days: "Jours sans Dépense",
    runway: "Autonomie (Survie)",
    years_to_fire: "Années jusqu'à F.I.R.E.",
    fire_target: "Objectif d'Indépendance",
    net_worth: "Patrimoine Net",
    liquid: "Disponible",
    invested: "Investi",
    locked_goals: "Objectifs Réservés",
    velocity: "Vitesse d'Enrichissement",
    savings_rate: "Taux d'Épargne",
    distribution: "Répartition des Comptes",
    in_bank: "En Banque",
    unconfirmed_alert: "Vous avez {count} transactions en attente de confirmation !",
    unconfirmed_sub: "Il peut s'agir d'abonnements ou d'entrées Telegram.",
    go_to_tx: "Aller aux Transactions",
    net_worth_in_bank: "En Banque (Réel) :",
    net_worth_in_goals: "Dans les Enveloppes :",
    net_worth_credits: "Crédits en Attente :",
    net_worth_debts: "Dettes en Attente :",
    current_month_balance_title: "Solde du Mois en Cours",
    pacing_title: "Rythme des Dépenses du Mois",
    pacing_time: "Temps ({days}j)",
    pacing_spent: "Budget consommé",
    eom_forecast_title: "Prévisions de Fin de Mois",
    eom_forecast_sub: "Estimation basée sur le taux de dépense quotidien ({rate}/j)",
    financial_pressure_title: "Calendrier & Pression Financière",
    pressure_upcoming_7d: "À Venir (7j)",
    pressure_remaining_month: "Mois Restant",
    pressure_next_month: "Mois Prochain",
    pressure_fixed_costs: "Coûts Fixes / Mois",
    outflows_plural: "{count} sorties",
    planned_plural: "{count} planifiées",
    pressure_base_msg: "Pression de base",
    wealth_breakdown: "Détail du Patrimoine",
    in_bank_label: "En banque : {amount}",
    credits_short: "{amount} Crédits",
    debts_short: "{amount} Dettes",
    wealth_velocity_label: "Vitesse d'Enrichissement : {amount} / jour",
    savings_rate_label: "Taux d'Épargne (Mois)",
    savings_rate_sub: "Objectif : 20% | Taux d'Investissement : {rate}%",
    fire_projection_title: "Projection F.I.R.E.",
    fire_years: "{years} ans",
    fire_years_over_50: "> 50 ans",
    fire_target_label: "Objectif d'Indépendance : {amount}",
    runway_label: "Autonomie (Survie) :",
    runway_value: "{years} ans",
    progression_12m: "Évolution du Patrimoine (12 mois)",
    account_distribution: "Répartition des Comptes",
    of_which_locked: "(Dont {amount} bloqués)",
    dow_title: "Dépenses par Jour de la Semaine",
    dow_avg: "Moyenne",
    weekend_weekday: "Week-end vs Semaine",
    weekday_label: "Lun-Ven",
    weekend_label: "Sam-Dim",
    month_rhythm: "Rythme du Mois",
    first_half_label: "Jours 1-15",
    second_half_label: "Jours 16-31",
    income_expense_ratio_title: "Ratio Revenus / Dépenses (Historique)",
    ratio_desc: "Pour chaque 1€ dépensé, vous gagnez {ratio}€",
    tx_count_label: "{count} tx",
    lifetime_flow: "Flux de Trésorerie Historique",
    lifetime_flow_desc: "Argent ayant transité par vos comptes depuis le premier jour.",
    generated_label: "Généré",
    burned_label: "Dépensé",
    monthly_income_history: "Historique Mensuel des Revenus (Global)",
    monthly_expense_history: "Historique Mensuel des Dépenses (Global)",
    monthly_income_tooltip: "Revenu Total",
    monthly_expense_tooltip: "Dépense Totale",
    top_expense_categories: "Principales Catégories de Dépenses (Global)",
    top_income_categories: "Principales Sources de Revenus (Global)",
    hall_of_fame: "Palmarès",
    max_single_expense: "Plus Forte Dépense Unique",
    max_single_income: "Plus Fort Revenu Unique",
    worst_day: "Pire Journée",
    max_no_spend_streak: "Série Maximale sans Dépense",
    days_suffix: "{days} j",
    days_suffix_streak: "{days} jours 🔥",
    table: {
      year: "Année",
      income: "Revenus",
      outflows: "Sorties",
      net_savings: "Épargne Nette",
      pct_sav: "% Épar"
    },
    time_horizon: "Horizon Temporel",
    years_label: "{years} Ans",
    annual_return: "Rendement Annuel des Investissements",
    capital_invested_compound: "Capital Investi (Intérêts Composés)",
    today_label: "Aujourd'hui",
    gain_label: "gain",
    liquidity_growth: "Liquidités (Croissance Linéaire)",
    avg_savings_label: "Épargne moyenne : {amount}/mois",
    projected_total_label: "Patrimoine Total Projeté",
    vs_today_label: "vs Aujourd'hui",
    trajectory_title: "Trajectoire du Patrimoine",
    invisible_tax_title: "Impôt Invisible (Inflation 2%)",
    inflation_desc: "Vos {amount} actuels de liquidités, s'ils restent inutilisés pendant {years} ans, perdront du pouvoir d'achat pour une valeur équivalente à :",
    year_n: "Année {n}",
    merchants_controparte: "Contrepartie",
    merchants_tx: "Transactions",
    merchants_total: "Total ({type})",
    merchants_outflow: "Dépensé",
    merchants_inflow: "Reçu",
    merchants_none: "Aucune contrepartie trouvée.",
    merchants_page: "Page {page} sur {total}",
    merchants_prev: "Précédent",
    merchants_next: "Suivant",
    merchants_by_amount: "Par Montant",
    merchants_by_freq: "Par Fréquence",
    budget_delete_title: "Supprimer le Budget",
    budget_delete_msg: "Voulez-vous supprimer le budget pour la catégorie {category} ?",
    budget_edit_title: "Modifier le Budget",
    budget_new_title: "Définir un Nouveau Budget",
    budget_cat_label: "Catégorie de Dépenses",
    budget_select_placeholder: "Sélectionner...",
    budget_limit_label: "Limite Maximale (€)",
    budget_cancel: "Annuler",
    budget_save: "Enregistrer",
    budget_spent_on: "Dépenses sur Budget",
    budget_set_limit: "+ Définir une Limite",
    budget_empty: "Vous n'avez pas encore défini de budgets mensuels. Cliquez sur \"+ Définir une Limite\" pour commencer.",
    budget_remaining: "Restant : {amount}",
    seasonality_title: "Moyenne Historique des Dépenses par Mois",
    rpg_title: "RPG Financier",
    rpg_subtitle: "Votre interface comportementale. Survivez au mois, battez vos records, montez de niveau.",
    rpg_boss_title: "Espace réservé aux combats de boss (Dettes) ou aux Quêtes",
    rpg_boss_sub: "Bientôt disponible...",
    investments_value: "Valeur Totale",
    investments_capital: "Capital Investi",
    investments_pnl: "PnL Global (Non Réalisé)",
    investments_positions: "Vos Positions",
    investments_tbl: {
      asset: "Actif",
      shares: "Parts / Actions",
      pmc: "PRU",
      current_price: "Cours Actuel",
      value: "Valeur",
      pnl: "PnL"
    },
    sankey: {
      title: "Flux de Trésorerie Mensuel ({month})",
      footer: "Revenus ➔ Budget Mensuel ➔ Dépenses / Épargne",
      budget_mensile: "Budget Mensuel",
      risparmio: "Épargne",
      avanzo: "Excédent",
      entrate: "Revenus",
      spese: "Dépenses",
      fondi_buste: "Enveloppes",
      erosione: "Érosion"
    },
    milestones: {
      title: "Les Piliers du Patrimoine",
      subtitle: "Votre parcours à travers les grandes étapes financières au fil du temps.",
      reached: "Niveau Atteint",
      real_worth: "Patrimoine Net Actuel",
      next_target: "Prochain Objectif : €{target}k"
    },
    streak: {
      title: "Série sans Dépense",
      days: "Jours",
      broken: "Vous avez dépensé aujourd'hui. La série est interrompue.",
      promising: "Début prometteur. Continuez ainsi !",
      rhythm: "Bon travail ! Vous prenez le rythme.",
      unstoppable: "INCROYABLE ! 🔥"
    },
    heatmap: {
      title: "Carte Comportementale",
      generating: "Génération de la carte...",
      outflows: "Sorties",
      inflows: "Entrées",
      balance: "Solde",
      mon: "Lun",
      wed: "Mer",
      fri: "Ven",
      jan: "Jan",
      feb: "Fév",
      mar: "Mar",
      apr: "Avr",
      may: "Mai",
      jun: "Jui",
      jul: "Jul",
      aug: "Aoû",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Déc"
    }
  },
  transactions: {
    title: "Transactions",
    subtitle: "Gérez, filtrez et ajoutez vos mouvements de fonds.",
    filters: "Filtres",
    new_tx: "Nouvelle Transaction",
    search: "Rechercher...",
    start_date: "Date de Début",
    end_date: "Date de Fin",
    category: "Catégorie",
    account: "Compte",
    payment_method: "Moyen de Paiement",
    type: "Type",
    status: "Statut",
    all: "TOUT",
    income: "Revenu",
    expense: "Dépense",
    transfer: "Transfert",
    unconfirmed: "À Confirmer",
    confirm_delete: "Supprimer la Transaction",
    delete_msg: "Êtes-vous sûr de vouloir supprimer cette transaction ? Cette action est irréversible.",
    date: "Date",
    description: "Description",
    amount: "Montant",
    notes: "Notes",
    envelope: "Enveloppe",
    is_envelope_spending: "Dépenser depuis l'Enveloppe",
    currency: "Devise",
    splits: "Partager les Frais",
    contacts: "Contacts",
    new_btn: "+ Nouveau",
    confirm_btn: "Confirmer",
    edit_btn: "Modifier",
    delete_btn: "Supprimer",
    no_tx_found: "Aucune transaction trouvée pour les filtres sélectionnés.",
    loading_data: "Chargement des données...",
    today: "Aujourd'hui",
    yesterday: "Hier",
    filter_bar: {
      from_date: "Depuis le",
      to_date: "Jusqu'au",
      search_placeholder: "Ex. Amazon, Dîner, Loyer...",
      search_label: "Recherche Libre",
      category_placeholder: "Toutes Catégories",
      account_placeholder: "Tous Comptes",
      quick_filters_label: "Filtres Rapides :",
      all: "Tout",
      today: "Aujourd'hui",
      last_7: "7 derniers jours",
      this_month: "Ce Mois",
      last_month: "Mois Dernier",
      only_unconfirmed: "Uniquement à Confirmer",
      found: "Trouvées :",
      delta: "Delta :"
    },
    modal: {
      edit_title: "✏️ Modifier",
      new_title: "✨ Nouveau",
      type_expense: "Dépense",
      type_income: "Revenu",
      type_transfer: "Transfert",
      date_label: "DATE",
      currency_label: "DEVISE",
      amount_label: "MONTANT ({currency})",
      description_label: "DESCRIPTION",
      real_bank_charge: "DÉBIT BANCAIRE RÉEL ({currency})",
      bank_charge_sub: "Le montant réellement prélevé par la banque sur votre relevé.",
      exchange_rate_label: "TAUX DE CHANGE (Frais Inclus)",
      exchange_rate_sub: "Calculé mathématiquement par le système.",
      category_label: "CATÉGORIE",
      new_category_link: "+ Nouveau",
      merchant_label: "CONTREPARTIE",
      new_merchant_link: "+ Nouveau",
      payment_method_label: "MOYEN DE PAIEMENT",
      new_payment_method_link: "+ Nouveau",
      money_movement_title: "MOUVEMENT D'ARGENT",
      new_account_btn: "+ Créer un Nouveau Compte",
      from_account_label: "PAYER AVEC",
      from_account_transfer_label: "DEPUIS LE COMPTE",
      to_account_label: "DÉPOSER SUR",
      to_account_transfer_label: "VERS LE COMPTE",
      envelope_title: "✉️ ENVELOPPES (Optionnel)",
      envelope_label: "LIER À L'ENVELOPPE",
      envelope_placeholder: "Aucune enveloppe...",
      use_envelope_money: "Utiliser les Fonds de l'Enveloppe",
      use_envelope_money_sub: "Cette dépense n'affectera pas votre budget mensuel car vous avez déjà mis ces fonds de côté.",
      debts_mode_label: "Générer des dettes/crédits liés à cette transaction",
      debts_add_item: "+ Ajouter une Ligne",
      debts_title: "Dettes / Crédits Liés",
      debts_empty: "Aucune dette liée.",
      debts_new_btn: "+ Ajouter",
      notes_label: "NOTES",
      tags_label: "Tags (Appuyer sur Entrée)",
      tags_placeholder: "Ex. vacances, cadeau...",
      cancel_btn: "Annuler",
      save_btn: "Enregistrer",
      saving_btn: "Enregistrement...",
      split_lent: "Prêté",
      split_borrowed: "Dette",
      split_to_whom: "À qui ?",
      split_amount_placeholder: "Part (€)",
      split_credito: "CRÉDIT",
      split_debito: "DETTE"
    },
    confirm_delete_title: "Supprimer la Transaction",
    confirm_delete_msg: "Êtes-vous sûr de vouloir supprimer cette transaction ? Cette action est irréversible et recalculera les soldes.",
    quick_add_modal: {
      category_title: "Nouvelle Catégorie ({type})",
      merchant_title: "Nouvelle Contrepartie",
      payment_title: "Nouveau Moyen de Paiement",
      name_placeholder: "Nom...",
      cancel: "Annuler",
      save: "Enregistrer"
    },
    new_account_modal: {
      title: "Nouveau Compte",
      name_placeholder: "Nom...",
      is_investment: "Compte d'Investissement",
      create: "Créer",
      cancel: "Annuler"
    }
  },
  auth: {
    login: {
      title: "MS Ledger",
      subtitle: "Protégez votre patrimoine.",
      email_username: "E-mail ou Nom d'utilisateur",
      email_placeholder: "Entrez votre adresse e-mail",
      password: "Mot de passe",
      forgot_password: "Mot de passe oublié ?",
      totp_code: "Code de Sécurité (2FA)",
      totp_placeholder: "000000",
      totp_desc: "Ouvrez votre application d'authentification pour générer le code.",
      remember_me: "Se souvenir de moi pendant 30 jours",
      submit_2fa: "Vérifier et se Connecter",
      submit_password: "Se Connecter avec un Mot de passe",
      back: "Retour",
      or: "Ou",
      face_id: "Se connecter avec Passkey"
    },
    register: {
      subtitle: "Créez un nouveau compte pour commencer.",
      username: "Nom d'utilisateur",
      username_placeholder: "ex. mario99",
      email: "Adresse e-mail",
      email_placeholder: "mario@email.com",
      password: "Mot de passe",
      confirm_password: "Confirmer le Mot de passe",
      submit: "S'inscrire",
      have_account: "Vous avez déjà un compte ?",
      login_link: "Se connecter"
    },
    forgot_password: {
      title: "Réinitialiser le Mot de passe",
      desc: "Saisissez votre e-mail pour recevoir le lien de réinitialisation.",
      email_placeholder: "Votre e-mail",
      submit: "Envoyer le Lien",
      success: "Vérifiez vos e-mails ! Nous avons envoyé les instructions."
    },
    reset_password: {
      title: "Nouveau Mot de passe",
      new_placeholder: "Nouveau Mot de passe",
      confirm_placeholder: "Confirmer le Mot de passe",
      submit: "Mettre à jour le Mot de passe"
    },
    errors: {
      email_required: "Saisissez votre e-mail ou votre nom d'utilisateur avant d'utiliser Face ID.",
      user_not_found: "Utilisateur non trouvé.",
      verification_failed: "Échec de la vérification.",
      biometric_error: "Erreur biométrique.",
      invalid_credentials: "Adresse e-mail ou mot de passe incorrect",
      passwords_mismatch: "Les mots de passe ne correspondent pas.",
      password_length: "Le mot de passe doit comporter au moins 6 caractères.",
      register_error: "Erreur lors de l'enregistrement.",
      request_error: "Erreur lors de la demande.",
      connection_error: "Échec de la connexion.",
      reset_error: "Erreur lors de la réinitialisation du mot de passe.",
      network_error: "Erreur réseau.",
      success_register: "Inscription réussie ! Redirection vers la page de connexion...",
      success_reset: "Mot de passe réinitialisé ! Vous pouvez maintenant vous connecter."
    }
  },
  balance: {
    title: "Clôtures et Soldes",
    subtitle: "Rapprochez les soldes de l'application avec les soldes réels de vos relevés bancaires.",
    reconciliation_btn: "Démarrer le Rapprochement",
    calculating: "Calcul en cours...",
    liquid_title: "Liquidités & Comptes Courants",
    investments_title: "Investissements",
    empty_msg: "Sélectionnez une date et cliquez sur \"Démarrer le Rapprochement\" pour commencer.",
    toasts: {
      load_err: "Erreur lors du chargement des soldes.",
      diff_err: "Le solde des comptes de liquidités doit correspondre exactement au solde attendu (Delta = 0).",
      success_close: "Compte rapproché avec succès !",
      close_err: "Erreur : {detail}"
    },
    table: {
      account: "Compte",
      expected_balance: "Solde Attendu (App)",
      actual_balance: "Solde Réel Bancaire",
      delta: "Écart (Delta)",
      action: "Action",
      close_btn: "Clôturer le Compte",
      closed_status: "Rapproché",
      never_closed: "Jamais clôturé",
      last_closure: "Dernier : {date} ({amount})",
      copy_expected: "Copier",
      copy_expected_mobile: "Copier Solde Attendu",
      expected_label_mobile: "Solde Attendu",
      actual_label_mobile: "Solde Bancaire Réel",
      close_btn_mobile: "Clôturer"
    }
  },
  calendar_page: {
    title: "Calendrier",
    subtitle: "Vue quotidienne de la trésorerie et projections des abonnements futurs.",
    today: "Aujourd'hui",
    loading_events: "Chargement des événements...",
    toasts: {
      load_err: "Erreur lors du chargement des données"
    },
    grid: {
      days: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
      days_short: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"]
    }
  },
  data_page: {
    title: "Anagraphics",
    subtitle: "Configurez les catégories, comptes, contreparties et cartes.",
    search_placeholder: "Rechercher...",
    new_btn: "Nouveau",
    tabs: {
      categories: "Catégories",
      accounts: "Comptes Bancaires",
      merchants: "Commerçants",
      payment_methods: "Moyens de Paiement",
      contacts: "Contacts"
    },
    table: {
      name: "Nom",
      type: "Type",
      account_type: "Type de Compte",
      actions: "Actions",
      no_categories: "Aucune catégorie trouvée.",
      no_accounts: "Aucun compte trouvé.",
      no_merchants: "Aucune contrepartie trouvée.",
      no_payments: "Aucun moyen de paiement trouvé.",
      no_contacts: "Aucun contact trouvé.",
      subcat_tooltip: "Ajouter une Sous-catégorie",
      investment_badge: "Investissement",
      liquidity_badge: "Liquidités"
    },
    modal: {
      delete_title: "Supprimer l'Élément",
      delete_message: "Êtes-vous sûr de vouloir supprimer cet élément ?",
      new_title: "Créer un Nouvel Élément",
      edit_title: "Modifier l'Élément",
      name_label: "Nom",
      transaction_type: "Type de Transaction",
      type_expense: "Dépense",
      type_income: "Revenu",
      type_transfer: "Transfert",
      parent_label: "Sous-catégorie de (Optionnel)",
      parent_none: "-- Aucune (Catégorie Principale) --",
      is_investment: "Compte d'Investissement",
      is_investment_sub: "Exclut ce compte du calcul des liquidités disponibles.",
      cancel: "Annuler",
      save: "Enregistrer",
      first_name: "Prénom",
      last_name: "Nom de Famille",
      email: "Adresse E-mail",
      phone_number: "Numéro de Téléphone",
      vat_number: "Numéro de TVA",
      tax_code: "Code Fiscal",
      address: "Adresse",
      website: "Site Web",
      matching_keywords: "Mots-clés de correspondance (séparés par des virgules)",
      is_credit_card: "Carte de Crédit",
      is_credit_card_sub: "Identifie ce compte comme une carte de crédit.",
      is_shared: "Compte Partagé",
      is_shared_sub: "Compte joint.",
      is_obsolete: "Marquer comme obsolète / inactif",
      is_obsolete_sub: "Masquer des listes principales.",
      show_obsolete: "Afficher les obsolètes",
      color: "Couleur",
      icon: "Icône",
      currency: "Devise"
    },
    toasts: {
      deleted: "Élément supprimé.",
      delete_err: "Impossible de supprimer : {detail}",
      created: "Élément créé !",
      updated: "Élément mis à jour !",
      save_err: "Erreur lors de l'enregistrement : {detail}",
      loading: "Chargement des données de base..."
    }
  },
  debts_page: {
    title: "Dettes & Crédits",
    subtitle: "Gérez les prêts à vos amis et vos dettes en cours.",
    new_friend: "Nouvel Ami",
    new_debt: "Nouvelle Dette",
    active_tab: "À Régler",
    settled_tab: "Régularisées",
    empty_msg: "Aucun élément dans cette section.",
    toasts: {
      load_err: "Erreur lors du chargement des données",
      deleted: "Dette supprimée !",
      delete_err: "Impossible de supprimer",
      contact_created: "Contact créé",
      debt_created: "Dette enregistrée",
      debt_updated: "Dette mise à jour",
      save_err: "Erreur lors de l'enregistrement",
      status_updated: "Statut mis à jour !",
      status_err: "Erreur lors de la mise à jour du statut",
      repay_linked: "Transaction liée !",
      repay_err: "Erreur",
      link_removed: "Lien supprimé !"
    },
    modal: {
      delete_title: "Supprimer la Dette",
      delete_message: "Êtes-vous sûr de vouloir supprimer cette dette ? Cela n'affectera pas vos soldes bancaires réels, mais supprimera le rappel.",
      friend_title: "Nouvel Ami",
      friend_name: "Nom de l'Ami",
      friend_placeholder: "Ex. John Doe",
      cancel: "Annuler",
      save: "Enregistrer",
      debt_title: "Dette",
      debt_amount: "Montant Total",
      debt_desc: "Description (Optionnel)",
      debt_desc_placeholder: "Ex. Dîner pizza, prêt...",
      repay_title: "Gérer le Rapprochement",
      repay_remaining: "Restant à régler : {amount}",
      repay_status: "Statut : {status}",
      repay_settled: "Régularisée",
      repay_active: "Active",
      repay_history: "Historique des Transactions Liées",
      repay_amount_applied: "Montant appliqué",
      repay_no_links: "Aucune transaction liée.",
      repay_link_new: "Lier une Nouvelle Transaction",
      repay_select_tx: "Sélectionner une transaction...",
      repay_amount_to_apply: "Montant à Attribuer à cette Dette",
      repay_settle_checkbox: "Marquer comme régularisée (Clôturer)",
      repay_submit: "Enregistrer le Rapprochement",
      toggle_repay_status: "Marquer comme {status}",
      type_lent: "Prêté (Crédit)",
      type_borrowed: "Emprunté (Dette)",
      reopen_debt: "Rouvrir la Dette",
      close_debt: "Clôturer la Dette",
      repay_total: "Remboursement",
      remaining_label: "Restant",
      tx_removed: "Transaction Supprimée",
      search_tx: "Rechercher une Transaction",
      settled_info: "Cette dette est actuellement régularisée. Utilisez le bouton 'Rouvrir la Dette' pour ajouter de nouvelles transactions, ou cliquez sur l'icône de corbeille dans l'historique pour supprimer un lien incorrect."
    },
    aggregations: {
      credits_title: "Crédits en Attente",
      debts_title: "Dettes en Attente",
      net_balance: "Solde Net",
      net_credits: "On vous doit {amount}",
      net_debts: "Vous devez {amount}",
      net_balanced: "Les soldes sont équilibrés",
      by_friend: "Situation par Ami",
      friend_credit: "Vous doit {amount}",
      friend_debt: "Vous lui devez {amount}",
      friend_settled: "Équilibré"
    },
    card: {
      lent: "Prêté à",
      borrowed: "Emprunté à",
      remaining: "Restant : {amount} sur {total}",
      settle_now: "Lier / Régler",
      settled: "Régularisée",
      no_desc: "Aucune description"
    }
  },
  documents_page: {
    inbox_title: "Boîte de Réception Telegram",
    empty_inbox: "Boîte vide. Envoyez un fichier au bot !",
    preview_title: "Aperçu du Document",
    fullscreen_btn: "Plein écran",
    decrypting: "Déchiffrement du fichier...",
    link_section_title: "Lier à une Transaction",
    search_placeholder: "Rechercher par description ou montant...",
    link_btn: "Lier ici",
    delete_btn: "Supprimer ce fichier",
    delete_confirm: "Supprimer le fichier définitivement ?",
    empty_selection: "Sélectionnez un document pour commencer",
    other_features_soon: "Autres fonctionnalités (Bientôt)",
    create_asset: "Créer un Actif",
    send_to_accountant: "Envoyer au Comptable",
    archive_title: "Archives Liées",
    tab_inbox: "Boîte",
    tab_archive: "Archives",
    empty_archive: "Aucun document lié trouvé.",
    linked_to: "Lié à la transaction:",
    unlink_btn: "Dissocier la Transaction",
    select_transaction_title: "Sélectionner la Transaction",
    alias_label: "Alias / Nom personnalisé",
    alias_placeholder: "Facture, reçu...",
    save_alias_btn: "Renommer",
    toasts: {
      preview_err: "Impossible de charger l'aperçu du document.",
      linked: "Document lié !",
      unlinked: "Document dissocié !",
      alias_updated: "Alias mis à jour !"
    }
  },
  envelopes_page: {
    title: "Enveloppes",
    subtitle: "Mettez de l'argent de côté pour vos dépenses futures et vos objectifs récurrents.",
    new_btn: "Nouvelle Enveloppe",
    liquid_title: "Liquidités disponibles sur le compte courant",
    liquid_desc: "Ce qui apparaît sur votre application bancaire",
    allocated_title: "Alloué dans les Enveloppes",
    allocated_desc: "Argent déjà « dépensé » mentalement",
    unallocated_title: "Encore Libre (Non Alloué)",
    unallocated_desc: "Votre VÉRITABLE patrimoine disponible",
    my_goals: "Vos Enveloppes",
    empty_msg: "Aucune enveloppe configurée. Créez-en une pour commencer à budgétiser !",
    toasts: {
      load_err: "Erreur lors du chargement des données",
      deleted: "Enveloppe supprimée !",
      delete_err: "Impossible de supprimer",
      saved: "Enveloppe enregistrée !",
      save_err: "Erreur lors de l'enregistrement de l'enveloppe"
    },
    card: {
      target: "Objectif : {target}",
      target_reached: "Terminé !",
      delete_confirm: "Êtes-vous sûr de vouloir supprimer cette enveloppe ?",
      no_desc: "Aucune description",
      remaining_to_target: "Restant : {amount}"
    },
    modal: {
      new_title: "Nouvelle Enveloppe",
      edit_title: "Modifier l'Enveloppe",
      delete_title: "Supprimer l'Enveloppe",
      name: "Nom de l'Enveloppe",
      name_placeholder: "Ex. Assurance Auto, Impôts...",
      allocated: "Montant Alloué (€)",
      target: "Montant Cible (Optionnel, €)",
      description: "Notes / Description",
      description_placeholder: "Ex. Échéance en novembre, objectif d'épargne mensuel...",
      cancel: "Annuler",
      save: "Enregistrer"
    }
  },
  goals_page: {
    title: "Objectifs Financiers",
    subtitle: "Planifiez vos objectifs d'épargne à long terme.",
    new_btn: "Nouvel Objectif",
    allocated_title: "Alloué dans les Objectifs",
    empty_msg: "Aucun objectif défini. Cliquez sur 'Nouvel Objectif' pour commencer à épargner !",
    toasts: {
      load_err: "Erreur lors du chargement des données",
      deleted: "Objectif supprimé !",
      delete_err: "Impossible de supprimer",
      saved: "Objectif enregistré !",
      save_err: "Erreur lors de l'enregistrement de l'objectif",
      select_account: "Sélectionnez un compte !",
      alloc_success: "Fonds alloués avec succès !",
      alloc_err: "Erreur d'allocation : {detail}"
    },
    card: {
      target: "Objectif : {amount} d'ici {date}",
      allocated: "Alloué : {amount} ({pct}%)",
      delete_confirm: "Êtes-vous sûr de vouloir supprimer cet objectif ?",
      target_date: "Échéance : {date}",
      add_funds: "Ajouter des Fonds"
    },
    modal: {
      new_title: "Nouvel Objectif",
      edit_title: "Modifier l'Objectif",
      delete_title: "Supprimer l'Objectif",
      name: "Nom de l'Objectif",
      name_placeholder: "Ex. Achat Maison, Voyage au Japon...",
      target: "Montant Cible (€)",
      deadline: "Date Limite",
      notes: "Notes / Description",
      notes_placeholder: "Détails de l'objectif...",
      cancel: "Annuler",
      save: "Enregistrer",
      allocate_title_prefix: "Déplacer les Fonds vers",
      allocate_from_account: "RETIRER DE QUEL COMPTE ?",
      allocate_select_account: "Choisir un compte...",
      allocate_desc: "L'argent restera comptabilisé dans votre Patrimoine Net, mais sera masqué de vos liquidités libres.",
      allocate_amount: "MONTANT (€)",
      allocate_date: "DATE",
      allocate_submit: "Déposer",
      optional: "Optionnel"
    }
  },
  investments_page: {
    title: "Investissements & Portefeuille",
    subtitle: "Suivez vos actifs, calculez votre PRU et enregistrez vos ordres d'achat/vente.",
    import_btn: "Importer un CSV",
    new_asset_btn: "Nouvel Actif",
    new_order_btn: "Enregistrer un Ordre",
    chart_title: "Historique de Performance du Portefeuille",
    empty_chart: "Aucune donnée historique pour le graphique.",
    positions_title: "Positions du Portefeuille",
    value: "Valeur",
    commission: "Commissions",
    order_type: "Type d'Ordre",
    date: "Date",
    shares: "Parts",
    price: "Prix",
    orders_history: "Historique des Ordres",
    loading_msg: "Initialisation du terminal...",
    updating_data: "Mise à jour des données...",
    broker_selector_all: "Tous les Courtiers",
    ledger_empty: "Le registre est vide. Enregistrez votre première transaction.",
    positions_empty: "Aucune position ouverte dans le portefeuille.",
    assets_empty: "Aucun actif enregistré.",
    tab_positions: "Positions Actives",
    tab_ledger: "Historique des Ordres (Registre)",
    tab_assets: "Annuaire des Actifs",
    broker_liquidity: "Liquidités Courtier",
    table: {
      asset: "Actif",
      shares: "Parts",
      pmc: "PRU",
      current_price: "Cours Actuel",
      total_value: "Valeur Totale",
      unrealized_pnl: "PnL Non Réalisé",
      date: "Date",
      event: "Événement",
      price: "Prix",
      value_eur: "Valeur (EUR)",
      actions: "Actions",
      ticker: "Ticker",
      name: "Nom",
      type: "Type",
      currency: "Devise",
      last_price: "Dernier Cours"
    },
    toasts: {
      load_err: "Erreur lors du chargement des données.",
      asset_deleted: "Actif supprimé !",
      asset_delete_err: "Impossible de supprimer l'actif.",
      order_deleted: "Ordre supprimé !",
      order_delete_err: "Impossible de supprimer l'ordre.",
      asset_saved: "Actif enregistré avec succès !",
      asset_save_err: "Erreur lors de l'enregistrement de l'actif.",
      order_saved: "Ordre enregistré avec succès !",
      order_save_err: "Erreur lors de l'enregistrement de l'ordre.",
      import_success: "Importation réussie !",
      import_err: "Erreur lors de l'importation."
    },
    modal: {
      asset_new_title: "Nouvel Actif",
      asset_edit_title: "Modifier l'Actif",
      ticker: "Ticker / Identifiant",
      ticker_placeholder: "Ex. SWDA.MI, AAPL, BTC...",
      name: "Nom de l'Actif",
      name_placeholder: "Ex. iShares MSCI World, Apple...",
      isin: "Code ISIN (Optionnel)",
      isin_placeholder: "Ex. IE00B4L5Y983...",
      asset_class: "Classe d'Actifs",
      asset_class_placeholder: "Ex. Actions, Crypto, Or...",
      currency: "Devise de Cotation",
      currency_placeholder: "EUR, USD, etc.",
      current_price: "Cours du Marché Actuel",
      search_ticker: "Rechercher le Ticker (Yahoo Finance)",
      ticker_not_found: "Ticker non trouvé sur Yahoo Finance.",
      ticker_verified: "Ticker Vérifié",
      symbol: "Symbole",
      instrument_name: "Nom de l'Instrument",
      original_currency: "Devise d'Origine",
      save_asset_btn: "Enregistrer l'Actif dans l'Annuaire",
      order_new_title: "Enregistrer un Nouvel Ordre",
      order_edit_title: "Modifier l'Ordre",
      select_asset: "Sélectionner un Actif...",
      select_account: "Compte à Débiter/Créditer...",
      order_type_buy: "ACHAT",
      order_type_sell: "VENTE",
      order_date: "Date de l'Ordre",
      order_shares: "Quantité (Parts)",
      order_price: "Prix Unitaire (€)",
      order_commission: "Commission (€, Optionnel)",
      broker_account: "Compte Courtier",
      event_type: "Type d'Événement",
      buy_option: "ACHAT (Acquisition)",
      sell_option: "VENTE (Cession)",
      deposit_option: "DÉPÔT (Déposer des espèces)",
      withdraw_option: "RETRAIT (Retirer des espèces)",
      dividend_option: "DIVIDENDE (Dividende)",
      interest_option: "INTÉRÊTS (Intérêts sur espèces)",
      fee_option: "FRAIS (Commission)",
      unit_price: "Prix Unitaire",
      total_value_eur: "Valeur Totale (€)",
      execution_date: "Date d'Exécution",
      confirm_order_btn: "Confirmer l'Ordre",
      registering: "Enregistrement...",
      order_notes: "Notes / Détails de la transaction",
      cancel: "Annuler",
      save: "Enregistrer",
      delete_confirm_asset: "Êtes-vous sûr de vouloir supprimer cet actif ? Tous les ordres associés seront également supprimés.",
      delete_confirm_order: "Êtes-vous sûr de vouloir supprimer cet ordre ? Le PRU et les quantités seront recalculés.",
      delete_order_title: "Supprimer l'Ordre",
      delete_order_msg: "Êtes-vous sûr de vouloir supprimer cet ordre du Registre ? L'opération est irréversible et recalculera immédiatement les positions et les graphiques."
    },
    import_page: {
      back_btn: "Retour au Terminal",
      title: "Importer les Données de Courtier",
      subtitle: "Gérez l'importation en masse de vos investissements.",
      system_aligned: "Système Aligné",
      ready_data: "Prêt pour de nouvelles données",
      step_staging: "Étape 1 : Zone de Transit (Staging)",
      select_broker: "Sélectionner le Courtier",
      file_label_csv: "Fichier CSV (Trade Republic)",
      upload_data_btn: "Téléverser les Données",
      step_processing: "Étape 2 : Traitement",
      processing_desc: "Analyse la zone de transit et crée les événements correspondants dans le Registre : achats, ventes, dividendes et frais seront calculés au centime près.",
      staging_status: "Statut de la Zone de Transit",
      ready_to_process: "Prêt à traiter",
      process_ledger_btn: "Traiter le Registre",
      step_sync: "Étape 3 : Synchronisation",
      sync_desc: "Synchronise les cours historiques depuis Yahoo Finance. Seules les données manquantes seront téléchargées afin d'optimiser les performances.",
      asset_prices: "Cours des Actifs",
      diff_update: "Mise à jour différentielle",
      smart_backfill_btn: "Smart Backfill",
      footer_info: "Identifiant de transaction détecté via le transaction_id unique du courtier.",
      safe_processing: "Traitement Sécurisé",
      dup_check: "Détection des Doublons Active",
      loading_config: "Chargement de la configuration...",
      toasts: {
        load_acc_err: "Impossible de charger les comptes.",
        select_file_acc: "Veuillez sélectionner un fichier et un compte de destination.",
        uploading_file: "Téléversement du fichier vers la zone de transit...",
        upload_err: "Erreur lors du téléversement",
        upload_conn_err: "Erreur de connexion lors du téléversement.",
        processing_ledger: "Traitement des transactions et mise à jour du Registre...",
        process_err: "Erreur lors du traitement du Registre.",
        process_conn_err: "Erreur de connexion lors du traitement.",
        syncing_prices: "Synchronisation des cours historiques depuis Yahoo Finance...",
        backfill_err: "Erreur lors de la récupération des cours.",
        backfill_conn_err: "Erreur de connexion lors de la récupération des cours."
      }
    }
  },
  recurring_page: {
    title: "Abonnements & Dépenses Récurrentes",
    subtitle: "Visualisez et gérez vos sorties de fonds planifiées et vos abonnements récurrents.",
    new_btn: "Nouvel Abonnement",
    active_tab: "Actifs",
    inactive_tab: "Désactivés",
    forecast_title: "Projections des Dépenses Futures",
    forecast_loading: "Calcul des projections...",
    forecast_30d: "Dépenses dans les 30 prochains jours",
    forecast_90d: "Dépenses dans les 90 prochains jours",
    forecast_365d: "Dépenses dans les 365 prochains jours",
    empty_msg: "Aucun abonnement configuré. Ajoutez votre premier abonnement !",
    delete_title: "Supprimer l'Abonnement",
    stats_7d: "7 Prochains Jours",
    stats_eom: "D'ici la Fin du Mois",
    stats_30d: "30 Prochains Jours",
    stats_next_month: "Mois Prochain",
    stats_12m: "12 Prochains Mois",
    stats_monthly_avg: "Moyenne Mensuelle",
    toasts: {
      load_err: "Erreur lors du chargement des données",
      deleted: "Abonnement supprimé !",
      delete_err: "Impossible de supprimer",
      saved: "Abonnement enregistré !",
      save_err: "Erreur lors de l'enregistrement de l'abonnement"
    },
    card: {
      frequency_label: "Fréquence :",
      next_date_label: "Prochain prélèvement :",
      account_label: "Compte :",
      status_label: "Statut :",
      active: "Actif",
      inactive: "Inactif",
      freq_daily: "Quotidien",
      freq_weekly: "Hebdomadaire",
      freq_monthly: "Mensuel",
      freq_yearly: "Annuel",
      delete_confirm: "Êtes-vous sûr de vouloir supprimer cet abonnement récurrent ?",
      suspend: "Suspendre",
      resume: "Reprendre"
    },
    modal: {
      new_title: "Nouvel Abonnement",
      edit_title: "Modifier l'Abonnement",
      description: "Description / Nom",
      description_placeholder: "Ex. Netflix, Spotify, Loyer...",
      amount: "Montant (€)",
      category: "Catégorie",
      account: "Compte de Débit",
      frequency: "Fréquence",
      next_date: "Prochaine Échéance",
      is_active: "Abonnement Actif (Génère de futures échéances)",
      cancel: "Annuler",
      save: "Enregistrer",
      none_placeholder: "Aucun..."
    }
  },
  wishlist: {
    delete_btn: "Supprimer",
    title: "Liste d'Envies (Temporisateur)",
    subtitle: "Enregistrez les achats non essentiels pour les laisser 'refroidir' et éviter les achats impulsifs.",
    add_btn: "Ajouter un Souhait",
    new_wish: "Nouveau Souhait",
    name: "Nom de l'Objet",
    name_placeholder: "Ex. Smartwatch, Nouvelles chaussures...",
    amount: "Montant (€)",
    category: "Catégorie",
    merchant: "Marchand / Marque",
    merchant_placeholder: "Sélectionnez un marchand (optionnel)...",
    product_url: "Lien Produit",
    product_url_placeholder: "Ex. https://amazon.fr/... (optionnel)",
    timer: "Période de Réflexion",
    timer_24: "24 Heures",
    timer_48: "48 Heures (Recommandé)",
    timer_72: "72 Heures",
    notes: "Notes Additionnelles",
    notes_placeholder: "Pourquoi je veux acheter ceci ? En ai-je vraiment besoin ?",
    cancel: "Annuler",
    save: "Enregistrer le Souhait",
    total_saved: "Épargne par Autocontrôle",
    active_wishes: "Période de Réflexion Active",
    archived_wishes: "Historique des Décisions",
    time_left: "Temps restant :",
    expired: "Temps Écoulé !",
    want_it_question: "Voulez-vous toujours l'acheter ?",
    yes_btn: "Oui, je le veux toujours",
    no_btn: "Non, j'ai changé d'avis",
    status_pending: "Réflexion",
    status_saved: "Épargné",
    status_bought: "Acheté",
    empty_active: "Aucun achat en phase de réflexion. Excellent autocontrôle !",
    empty_archive: "Aucune décision enregistrée dans l'historique.",
    delete_confirm: "Êtes-vous sûr de vouloir supprimer ce souhait ?",
    toasts: {
      load_err: "Erreur lors du chargement des souhaits",
      saved: "Souhait enregistré ! Le temporisateur de refroidissement a commencé.",
      save_err: "Impossible d'enregistrer le souhait",
      deleted: "Souhait supprimé",
      delete_err: "Impossible de supprimer",
      decision_saved: "Félicitations pour votre autocontrôle ! {amount}€ ont été déplacés dans votre enveloppe d'Épargne.",
      decision_bought: "Souhait confirmé. Vous pouvez procéder à l'achat !"
    }
  }
};
